import { BASE_STATS, INITIAL_HERO_INVENTORY } from './utils/constants';
import { HERO_CLASS_TYPES, getHeroSkins } from '../Helpers/heroAbilities';

const normalizeClassType = (classType) => {
    if (!classType) return HERO_CLASS_TYPES.SWORDER;
    const upper = String(classType).toUpperCase();
    return upper === 'WARRIOR' ? HERO_CLASS_TYPES.SWORDER : upper;
};

const buildStats = (classType, rawStats = {}) => {
    const base = BASE_STATS[classType] || BASE_STATS.SWORDER;
    return {
        strength: parseInt(rawStats.strength ?? base.strength ?? 10, 10),
        intelligence: parseInt(rawStats.intelligence ?? base.intelligence ?? 10, 10),
        dexterity: parseInt(rawStats.dexterity ?? base.dexterity ?? 10, 10),
        vitality: parseInt(rawStats.vitality ?? base.vitality ?? 10, 10),
        health: parseInt(rawStats.health ?? base.health ?? 50, 10),
        maxHealth: parseInt(rawStats.maxHealth ?? base.maxHealth ?? 50, 10),
        mana: parseInt(rawStats.mana ?? base.mana ?? 30, 10),
        maxMana: parseInt(rawStats.maxMana ?? base.maxMana ?? 30, 10),
    };
};

// Returns a plain, serializable hero object. No prototype methods, no class instances.
export const createHero = (rawHero = {}) => {
    const classType = normalizeClassType(rawHero.classType);
    const skins = getHeroSkins(classType);
    const now = new Date().toISOString();

    return {
        name: rawHero.name || 'Hero',
        gender: rawHero.gender || { id: 'male', label: 'Homme' },
        classType,
        skinMale: skins.male,
        skinFemale: skins.female,
        stats: buildStats(classType, rawHero.stats),
        inventory: rawHero.inventory || INITIAL_HERO_INVENTORY,
        equipment: rawHero.equipment || {},
        skills: rawHero.skills || [],
        level: parseInt(rawHero.level ?? 1, 10),
        xp: parseInt(rawHero.xp ?? 0, 10),
        gold: parseInt(rawHero.gold ?? 100, 10),
        position: rawHero.position || { mapId: 'map1', x: 0, y: 1 },
        createdAt: rawHero.createdAt || now,
        updatedAt: now,
    };
};
